import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.iterator.js";
import { getCountries, getCountryCallingCode } from 'libphonenumber-js/max';
const countries = getCountries();
export const phoneCountriesRaw = countries.map(country => ({
  alpha2: country,
  code: getCountryCallingCode(country)
}));
export const callingCodePriorities = {
  '1': 'US',
  '7': 'RU',
  '39': 'IT',
  '44': 'GB',
  '47': 'NO',
  '61': 'AU',
  '212': 'MA',
  '262': 'YT',
  '358': 'FI',
  '590': 'GP',
  '599': 'BQ'
};
export const getDuplicatesCallingCode = () => {
  const duplicates = {};
  phoneCountriesRaw.forEach(c => {
    if (!duplicates[c.code]) duplicates[c.code] = [];
    duplicates[c.code].push(c);
  });
  const duplicatesClean = {};
  Object.entries(duplicates).forEach(([key, entry]) => {
    if (entry.length > 1) duplicatesClean[key] = entry;
  });
  return duplicatesClean;
};
export const getCountryCodeFromCallingCode = code => {
  var _phoneCountriesRaw$fi, _phoneCountriesRaw$fi2;
  if (callingCodePriorities[code]) return callingCodePriorities[code];
  return (_phoneCountriesRaw$fi = (_phoneCountriesRaw$fi2 = phoneCountriesRaw.find(cc => cc.code === code)) === null || _phoneCountriesRaw$fi2 === void 0 ? void 0 : _phoneCountriesRaw$fi2.alpha2) !== null && _phoneCountriesRaw$fi !== void 0 ? _phoneCountriesRaw$fi : null;
};